export const SET_CURRENT_TABLE_OF_OFFERS =
  "Setze den aktuellen Table Of Offers";
